import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './HomePage.css';
import Header from '../components/Header';

function HomePage() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    console.log(currentUser);
  }, [currentUser]);

  return (
    <div className="home-container">
      <Header />
      <div className="content-card">
        {currentUser && <p className="subtitle">
          Welcome, {currentUser.displayName}
        </p>}
        <h1 className="title">
          Who Is Most Likely?
        </h1>
        <p className="subtitle">
          The ultimate drinking game for friends!
        </p>
        
        <div className="button-container">
          {/* {currentUser ? <button
            onClick={() => navigate('/create')}
            className="button create-home-button"
          >
            Create Party
          </button> : <button
            onClick={() => navigate('/login')}
            className="button create-home-button"
          >
            Sign In To Create Party
          </button>} */}
          <button
            // onClick={() => navigate('/login')}
            onClick={() => window.open('https://apps.apple.com/app/id6757329302', '_blank')}
            className="button create-home-button"
          >
            Download App To Create Party
          </button>
          
          <button
            onClick={() => navigate('/join')}
            className="button join-home-button"
          >
            Join Party
          </button>
        </div>

        <div className="footer-text">
          <p>Get ready to discover who among your friends</p>
          <p>is most likely to do the craziest things! 🎉</p>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
